// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"123":"case","357":"casesFrame","794":"cases"}[chunkId] || chunkId) + "." + {"123":"219b578b","357":"e8790f86","762":"8d5ead0a","794":"58480242","865":"bc9b7b29","867":"4e3352cf"}[chunkId] + ".css";
};